"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _formik = require("formik");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wrapper = function Wrapper(_ref) {
  var _profile$contactPermi, _profile$contactPermi2, _profile$contactPermi3, _profile$contactPermi4, _profile$contactPermi5, _profile$contactPermi6;

  var translations = _ref.translations,
      profile = _ref.profile,
      onError = _ref.onError,
      onProfileSaveSuccess = _ref.onProfileSaveSuccess;

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting,
        resetForm = _ref2.resetForm;

    var params = _objectSpread(_objectSpread({}, profile), {}, {
      contactPermissions: {
        inAppNotificationsAccepted: values.pushNotification,
        smsNotificationsAccepted: values.sms,
        emailNotificationsAccepted: values.email
      }
    });

    _axios.default.put("/me", params).then(function (_ref3) {
      var data = _ref3.data;
      resetForm({
        values: values,
        touched: false
      });
      setSubmitting(false);
      onProfileSaveSuccess();
    }).catch(function (_ref4) {
      var response = _ref4.response;
      setSubmitting(false);
      onError(response);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      pushNotification: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi = profile.contactPermissions) === null || _profile$contactPermi === void 0 ? void 0 : _profile$contactPermi.inAppNotificationsAccepted,
      sms: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi2 = profile.contactPermissions) === null || _profile$contactPermi2 === void 0 ? void 0 : _profile$contactPermi2.smsNotificationsAccepted,
      email: profile === null || profile === void 0 ? void 0 : (_profile$contactPermi3 = profile.contactPermissions) === null || _profile$contactPermi3 === void 0 ? void 0 : _profile$contactPermi3.emailNotificationsAccepted,
      allChecked: (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi4 = profile.contactPermissions) === null || _profile$contactPermi4 === void 0 ? void 0 : _profile$contactPermi4.inAppNotificationsAccepted) && (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi5 = profile.contactPermissions) === null || _profile$contactPermi5 === void 0 ? void 0 : _profile$contactPermi5.smsNotificationsAccepted) && (profile === null || profile === void 0 ? void 0 : (_profile$contactPermi6 = profile.contactPermissions) === null || _profile$contactPermi6 === void 0 ? void 0 : _profile$contactPermi6.emailNotificationsAccepted)
    },
    onSubmit: onSubmit
  }, function (_ref5) {
    var isValid = _ref5.isValid,
        values = _ref5.values,
        errors = _ref5.errors,
        touched = _ref5.touched,
        dirty = _ref5.dirty,
        handleChange = _ref5.handleChange,
        handleBlur = _ref5.handleBlur,
        handleSubmit = _ref5.handleSubmit,
        isSubmitting = _ref5.isSubmitting,
        setFieldValue = _ref5.setFieldValue,
        setValues = _ref5.setValues,
        resetForm = _ref5.resetForm;

    var handleCheckAllChanged = function handleCheckAllChanged(e) {
      var checked = e.target.checked;
      setValues({
        sms: checked,
        email: checked,
        pushNotification: checked
      });
    };

    return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, {
      padding: "0 1rem 1rem"
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.CardTitle, null, translations.contactPermission), /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowText, {
      isNormal: true
    }, translations.optInMarketing), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
      isSmallerText: true,
      alignItems: "center",
      checked: values.pushNotification,
      label: translations.pushNotification,
      onChange: function onChange(e) {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      name: "pushNotification"
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
      isSmallerText: true,
      alignItems: "center",
      checked: values.sms,
      label: translations.sms,
      onChange: function onChange(e) {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      name: "sms"
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
      isSmallerText: true,
      alignItems: "center",
      checked: values.email,
      label: translations.email,
      onChange: function onChange(e) {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      name: "email"
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowText, {
      isNormal: true
    }, translations.optInConsent), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
      isSmallerText: true,
      alignItems: "center",
      checked: values.pushNotification && values.sms && values.email,
      label: translations.optInCheckAll,
      onChange: function onChange(e) {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleCheckAllChanged(e);
      }
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      disabled: !dirty,
      isLoading: isSubmitting,
      isSmall: true,
      onClick: handleSubmit
    }, translations.saveChanges)));
  });
};

var _default = Wrapper;
exports.default = _default;